/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortfolioStatus = {
    Initial: 'INITIAL',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    InClosing: 'IN_CLOSING',
    Closed: 'CLOSED'
} as const;
export type PortfolioStatus = typeof PortfolioStatus[keyof typeof PortfolioStatus];


export function instanceOfPortfolioStatus(value: any): boolean {
    for (const key in PortfolioStatus) {
        if (Object.prototype.hasOwnProperty.call(PortfolioStatus, key)) {
            if (PortfolioStatus[key as keyof typeof PortfolioStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioStatusFromJSON(json: any): PortfolioStatus {
    return PortfolioStatusFromJSONTyped(json, false);
}

export function PortfolioStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioStatus {
    return json as PortfolioStatus;
}

export function PortfolioStatusToJSON(value?: PortfolioStatus | null): any {
    return value as any;
}

export function PortfolioStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioStatus {
    return value as PortfolioStatus;
}

